<template>
	<div class="cassie-vertical-md">
		<TextField
			:value="item[nameKey]"
			label="Name *"
			rules="required"
			@input="updateItem(nameKey, $event)"
		/>
	</div>
</template>

<script>
import TextField from '../../../../../../shared/components/text-field.vue'
import { brandOptions } from '../../../../../../shared/state/brands.js'
export default {
	components: { TextField },
	props: {
		item: Object,
		nameKey: String
	},
	setup () {
		return {
			brandOptions
		}
	},
	methods: {
		updateItem (property, value) {
			this.$emit('update:item', { ...this.item, [property]: value })
		}
	}
}
</script>
